jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   // $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   // });
document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
  ele.addEventListener("input", function () {
    if (this.value < 0) {
        this.value = 0;
    }
  });
});
  $(document).on("variant:changed", function (evt) {
    // console.log(evt.currentVariant.title);
    if (evt.currentVariant.title.includes('Customized')) {
        document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
            ele.removeAttribute("disabled");
        });
    } else {
        document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
            ele.setAttribute("disabled", "disabled");
        });
    };
  });

  function markNewsletterPopupSuccess() {
    var $popup = $('#sr4-popup__newsletter');
    if ($popup.length) $popup.addClass('is-step-success');
  }

  if ($('#sr4-popup__newsletter .sr4-newsletter__success--popup').filter(':visible').length) {
    markNewsletterPopupSuccess();
  }

  $(document).on('mail.subscribe.success', function () {
    markNewsletterPopupSuccess();
  });

  $(document).on('click', '[data-copy-discount]', function (e) {
    e.preventDefault();
    var $btn = $(this);
    var input = $btn.closest('.sr4-newsletter__code-wrap').find('.sr4-newsletter__code')[0];
    if (!input) return;
    var code = input.value;
    var done = function () {
      $btn.addClass('is-copied');
      $btn.attr('aria-label', 'Copied');
      setTimeout(function () {
        $btn.removeClass('is-copied');
        $btn.attr('aria-label', 'Copy discount code');
      }, 1500);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(function () {
        input.select();
        document.execCommand('copy');
        done();
      });
    } else {
      input.select();
      document.execCommand('copy');
      done();
    }
  });

});